import moment from 'moment'
import {useDispatch} from 'react-redux'
import {getTimeRangeLabel} from '../../../../../core/google-tag-manager/helpers/time-range-label-helper'
import {selectFromTimePeriodEvent} from '../../../../../core/google-tag-manager/reports/select-from-time-period-event'
import useTypedSelector from '../../../../../hooks/use-typed-selector'
import {setSelectedFromTimeRange} from '../../../../../store/state/report-filters/action-creators'
import {reportsFilterFromDataSelector} from '../../../../../store/state/report-filters/selectors'
import {FilterTimeRangeSelectOptionProps} from '../../../contexts/types/filter-time-range'
import {usePagedReports} from '../../../contexts/use-paged-reports'
import {getReportMonths} from '../../data-helpers'

import * as Styles from './time-period.styled'

export function TimePeriodFrom(): JSX.Element {
    const dispatch = useDispatch()
    const selectedFromTimeRange = useTypedSelector(reportsFilterFromDataSelector)

    const {earliestPeriodEndDate, latestPeriodEndDate} = usePagedReports()
    const startDate = earliestPeriodEndDate ? moment(earliestPeriodEndDate) : moment()
    const endDate = latestPeriodEndDate ? moment(latestPeriodEndDate) : moment()

    const defaultSelectedFromTimeRange: FilterTimeRangeSelectOptionProps[] = getReportMonths(
        startDate,
        endDate,
    )
    function onChangeWrapper(event: React.ChangeEvent<HTMLSelectElement>): void {
        event.preventDefault()
        selectFromTimePeriodEvent(
            getTimeRangeLabel(defaultSelectedFromTimeRange, selectedFromTimeRange),
            getTimeRangeLabel(defaultSelectedFromTimeRange, event.target.value),
        )
        dispatch(setSelectedFromTimeRange(event.target.value))
    }

    return (
        <Styles.TimePeriodContent>
            <Styles.Label>Time Period From:</Styles.Label>
            <Styles.Input>
                <Styles.Select onChange={onChangeWrapper} value={selectedFromTimeRange}>
                    <option key="default-option" value="">
                        - All -
                    </option>
                    {defaultSelectedFromTimeRange.map(({value, label}) => (
                        <option key={value} value={value}>
                            {label}
                        </option>
                    ))}
                </Styles.Select>
            </Styles.Input>
        </Styles.TimePeriodContent>
    )
}
